// components/landing/PlanoAnualDetails.js
import { FaCalculator, FaWhatsapp, FaCheck, FaTimes } from 'react-icons/fa';

const PlanoAnualDetails = ({ onClose }) => {
  // Valores do cálculo
  const monthlyPrice = 149.90;
  const annualTotal = monthlyPrice * 12;
  const discount = annualTotal * 0.10;
  const finalAnnualPrice = annualTotal - discount;
  const effectiveMonthlyPrice = finalAnnualPrice / 12;
  const monthlySavings = monthlyPrice - effectiveMonthlyPrice;
  const totalSavings = monthlySavings * 12;

  const whatsappUrl = "https://wa.me/5582996992182?text=Olá! Gostaria de saber mais sobre o plano App Nativo Premium.";

  const handleWhatsAppClick = () => {
    window.open(whatsappUrl, '_blank');
  };

  const beneficiosDesconto = [
    "Economia garantida de R$ 179,89 no primeiro ano",
    "Mensalidade reduzida para R$ 134,91/mês",
    "Todos os benefícios do plano mensal incluídos",
    "Ativação imediata após o pagamento",
    "Suporte prioritário 24/7",
    "30 dias de garantia incondicional"
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-3 sm:p-4 z-50">
      <div className="bg-white rounded-xl sm:rounded-2xl lg:rounded-3xl max-w-md sm:max-w-lg lg:max-w-2xl w-full max-h-[95vh] sm:max-h-[90vh] overflow-y-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 rounded-t-xl sm:rounded-t-2xl lg:rounded-t-3xl p-3 sm:p-4 lg:p-6">
          <div className="flex items-center justify-between">
            <div className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-2 sm:px-3 lg:px-4 py-1 sm:py-2 rounded-full">
              <span className="font-semibold text-xs sm:text-sm">10% DE DESCONTO</span>
            </div>
            
            {/* Botão X para fechar */}
            <button
              onClick={onClose}
              className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-all duration-200"
            >
              <FaTimes className="text-lg sm:text-xl" />
            </button>
          </div>
        </div>

        {/* Conteúdo */}
        <div className="p-3 sm:p-4 lg:p-6">
          {/* Título Principal */}
          <div className="text-center mb-4 sm:mb-5 lg:mb-6">
            <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 mb-2 sm:mb-3">
              Economize <span className="text-green-600">R$ {totalSavings.toFixed(2)}</span>
            </h1>
            <p className="text-gray-600 text-xs sm:text-sm lg:text-base">
              Com o plano anual você paga menos e tem mais benefícios
            </p>
          </div>

          {/* Comparação de Valores */}
          <div className="bg-gray-50 rounded-lg sm:rounded-xl lg:rounded-2xl p-3 sm:p-4 lg:p-5 border border-gray-200 mb-4 sm:mb-5 lg:mb-6">
            <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
              <div className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 bg-gradient-to-br from-green-500 to-emerald-600 rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0">
                <FaCalculator className="text-white text-sm sm:text-lg lg:text-xl" />
              </div>
              <div>
                <h2 className="text-base sm:text-lg lg:text-xl font-bold text-gray-900">Comparação de Valores</h2>
                <p className="text-gray-600 text-xs sm:text-sm">Veja a diferença no seu investimento</p>
              </div>
            </div>

            <div className="space-y-3 sm:space-y-4">
              {/* Plano Mensal */}
              <div className="bg-white rounded-lg p-2 sm:p-3 lg:p-4 border border-gray-300">
                <div className="flex justify-between items-start gap-2">
                  <div className="min-w-0 flex-1">
                    <h3 className="font-semibold text-gray-900 text-sm sm:text-base">Plano Mensal</h3>
                    <p className="text-gray-600 text-xs">Pagamento mensal</p>
                  </div>
                  <div className="text-right flex-shrink-0">
                    <div className="text-base sm:text-lg lg:text-xl font-bold text-gray-700">R$ 149,90</div>
                    <div className="text-gray-500 text-xs">por mês</div>
                  </div>
                </div>
                <div className="mt-2 text-gray-600 text-xs">
                  <div className="flex justify-between py-1 border-b border-gray-200">
                    <span>12 meses:</span>
                    <span className="font-semibold">R$ 1.798,80</span>
                  </div>
                </div>
              </div>

              {/* VS Separator */}
              <div className="flex items-center justify-center">
                <div className="bg-gray-300 h-px flex-1"></div>
                <div className="mx-2 sm:mx-3 px-2 sm:px-3 py-1 bg-gray-100 rounded-full">
                  <span className="text-gray-600 font-bold text-xs">VS</span>
                </div>
                <div className="bg-gray-300 h-px flex-1"></div>
              </div>

              {/* Plano Anual */}
              <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-lg p-2 sm:p-3 lg:p-4 border border-green-200 relative">
                {/* Badge -10% reposicionado */}
                <div className="absolute -top-2 -right-2 sm:-top-2 sm:-right-2 bg-green-500 text-white text-xs font-bold px-2 sm:px-3 py-1 rounded-full shadow-lg z-10">
                  -10%
                </div>
                
                <div className="flex justify-between items-start gap-2">
                  <div className="min-w-0 flex-1">
                    <h3 className="font-semibold text-gray-900 text-sm sm:text-base">Plano Anual</h3>
                    <p className="text-green-700 text-xs">Mais econômico</p>
                  </div>
                  <div className="text-right flex-shrink-0">
                    <div className="text-base sm:text-lg lg:text-xl font-bold text-green-600">R$ 134,91</div>
                    <div className="text-green-700 text-xs">por mês</div>
                  </div>
                </div>
                
                <div className="mt-2 space-y-1 text-xs">
                  <div className="flex justify-between text-gray-600">
                    <span>Valor anual:</span>
                    <span className="font-semibold">R$ 1.798,80</span>
                  </div>
                  <div className="flex justify-between text-green-600">
                    <span>Desconto aplicado:</span>
                    <span className="font-bold">- R$ 179,89</span>
                  </div>
                  <div className="flex justify-between text-gray-700 font-semibold border-t border-green-200 pt-1">
                    <span>Total com desconto:</span>
                    <span>R$ 1.619,01</span>
                  </div>
                </div>
              </div>

              {/* Economia Total */}
              <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg p-3 sm:p-4 text-white text-center">
                <div className="text-lg sm:text-xl lg:text-2xl font-bold mb-1">R$ {totalSavings.toFixed(2)}</div>
                <div className="text-blue-100 text-xs sm:text-sm">Economia total no primeiro ano</div>
                <div className="text-blue-200 text-xs mt-1">
                  Equivale a <span className="font-semibold">{Math.round(totalSavings / monthlyPrice)} meses grátis</span>
                </div>
              </div>
            </div>
          </div>

          {/* Benefícios do Desconto */}
          <div className="bg-gray-50 rounded-lg sm:rounded-xl lg:rounded-2xl p-3 sm:p-4 lg:p-5 border border-gray-200 mb-4 sm:mb-5 lg:mb-6">
            <h3 className="font-bold text-gray-900 text-base sm:text-lg lg:text-xl mb-2 sm:mb-3 lg:mb-4">Benefícios Incluídos</h3>
            <div className="space-y-2 sm:space-y-3">
              {beneficiosDesconto.map((beneficio, index) => (
                <div key={index} className="flex items-start gap-2 sm:gap-3">
                  <FaCheck className="text-green-500 mt-0.5 flex-shrink-0 text-xs sm:text-sm" />
                  <span className="text-gray-700 text-xs sm:text-sm lg:text-base leading-relaxed">{beneficio}</span>
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-lg sm:rounded-xl lg:rounded-2xl p-3 sm:p-4 lg:p-5 text-center text-white">
            <h3 className="font-bold text-base sm:text-lg lg:text-xl mb-1 sm:mb-2">Garanta Seu Desconto</h3>
            <p className="text-gray-300 text-xs sm:text-sm lg:text-base mb-3 sm:mb-4">
              Não perca esta oportunidade de economizar enquanto transforma seu negócio
            </p>
            
            <button
              onClick={handleWhatsAppClick}
              className="w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-bold py-2 sm:py-3 px-4 rounded-lg sm:rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg flex items-center justify-center gap-2 sm:gap-3 mx-auto"
            >
              <FaWhatsapp className="text-base sm:text-lg lg:text-xl" />
              <span className="text-sm sm:text-base">Quero o Desconto Anual</span>
            </button>
            
            <p className="text-gray-400 text-xs mt-2 sm:mt-3">
              ⚡ Ativação imediata • 🛡️ 30 dias de garantia
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanoAnualDetails;